// ~~ CTableSwitch Preparing the relevant data before write it on table ~~ //
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import * as actionsAlerts from '../../actions/AlertsActions';
import * as actionsAssessments from '../../actions/AssessmentsActions';
import * as actionsCouples from '../../actions/CouplesActions';
import * as actionsCustomers from '../../actions/CustomersActions';
import * as actionsGlobals from '../../actions/GlobalsActions';
import * as installActions from '../../actions/InstallActions';
import * as actionsMapHandler from '../../actions/MapActionsHandler';
import * as actionsMobileDisplay from '../../actions/MobileStateAction';
import * as mobileTasksActions from '../../actions/MobileTasksActions';
import * as mobileAlertsActions from '../../actions/MobileAlertsActions';
import * as mobileDevicesActions from '../../actions/MobileDevicesActions';
import * as actionsNoiseAlerts from '../../actions/NoiseAlertsActions';
import * as actionsProjects from '../../actions/ProjectsActions';
import * as actionsPrsTranAlerts from '../../actions/PrsTransientAlertsActions';
import * as actionsSOPs from '../../actions/SOPsActions';
import * as actionsSensors from '../../actions/SensorsActions';
import { selectFeature } from "../../actions/selectors";
import { setFieldText, setMapDrawMode } from "../../actions/setters";
import { featuresTypes } from '../../components/Map/Layers/Options';
import TableSwitch from '../../components/TableSwitch/TableSwitch';
import { DRAW_TYPES, routes } from '../../constants/Misc';
import { getSamples, getSamplesAction } from '../../actions/actions';
import { fetchMobileAlertSamples } from '../../actions/MobileAlertsActions';
import { ACTIONS } from '../../actions/MobileTasksActions';
// Linking between the ReduxState (store) and UI Components
const mapStateToProps = (state, ownProps) => {

  // console.log('state mapStateToProps', state);
  // console.log('ownProps mapStateToProps', ownProps);


  const { units, timeZone } = state.local;
  const distanceFactor = state.local.factor[units];
  const optionList = state.leaksList.optionList;
  const user = state.leaksList.user;
  const filters = state.leaksList.filters;
  const selectedProjectId = state.leaksList.selectedProject;
  const selectedProjectItem =
    state.leaksList.projectsList.items[
    state.leaksList.projectsList.projectIndexMap[selectedProjectId]
    ];
  const projectState = state.leaksList.leaksByProject[selectedProjectId];
  let selectedFeature = state.leaksList.leaksByProject.selectedFeature;
  const {
    displayAssessments,
    displayAssessmentsOnlyRealLeaks,
    selectedAssessment,
  } = state.leaksList.leaksByProject;
  const alertsContextMenu = state.leaksList.pressure.context;
  const { selectedManageItem, managementContext } = state.manage;
  let assessmentsData = null;
  let hasAssessments = false;
  const path = ownProps.path;
  const installContext = state.install.installContext;
  const sensorsContext = projectState && projectState.sensors ? projectState.sensors.sensorsContext : 'LeaksSensors';
  const planningState = state.planning;
  const isDisplayCityColumn =
    selectedProjectItem != null
      ? selectedProjectItem.IsDisplayCityColumn
      : false;
  const addingManualAlertMode = state.temp.newManualAlert != null;
  const addingManualNoiseAlertMode = state.temp.newManualNoiseAlert != null;
  const noiseAlertsSortParams = state.noiseAlerts.sortBy;
  const burstAlertsSortParams = state.burst.sortBy;
  const mobileTasksSort = state.mobile.tasks.mobileTasksSort;
  const mobileAlertsSort = state.mobile.alerts.mobileAlertsSort;
  const mobileDevicesSort = state.mobile.devices.sort;
  const mobileTasksFilters = state.mobile.tasks.mobileTasksFilters;
  const mobileAlertsFilters = state.mobile.alerts.mobileAlertsFilters;
  const valveAlertsFilters = state.valve.filters;
  const burstAlertsFilters = state.burst.filters;

  const mobileDisplayMode = state.mobile.modeState.mode;
  let items = [];
  let indexMap = {};
  let title = path[0].toUpperCase() + path.slice(1);

  // let pathName = path[0].toUpperCase() + path.slice(1);
  // let title = ownProps.t(pathName);
  // console.log('title', title);


  if (displayAssessments) {
    title += ' > Assessments';
  }
  if (path === 'manage') {
    title = 'Management > ';
    title += managementContext;
  }

  if (projectState != null) {
    switch (ownProps.path) {
      case routes.ALERTS:
        switch (alertsContextMenu) {
          case 'alerts':
            items = projectState.items;
            indexMap = projectState.indexMap;
            break;

          case 'prsAlerts':
            title = 'Pressure Alerts';
            items = state.leaksList.pressure.transientAlerts.alerts;
            indexMap = state.leaksList.pressure.transientAlerts.indexMap;
            break;

          case 'noise':
            title = 'Noise Alerts';
            items = state.noiseAlerts.items;
            indexMap = state.noiseAlerts.indexMap;
            selectedFeature = state.noiseAlerts.selected;
            break;

          case 'valve':
            title = 'Valve Alerts';
            items = state.valve.valveAlerts;
            indexMap = state.valve.alertsIndexMap;
            selectedFeature = state.valve.selectedAlert;
            break;

          case 'burst':
            title = 'Burst Alerts';
            items = state.burst.burstAlerts;
            indexMap = state.burst.alertsIndexMap;
            selectedFeature = state.burst.selectedAlert;
            break;

          default:
            break;
        }
        break;
      case routes.SENSORS:
        if (sensorsContext === 'PressureSensors') {
          // Use pressure sensors from separate API
          items = projectState.sensors.pressureSensors.items || [];
          indexMap = projectState.sensors.pressureSensors.indexMap || {};
          title = 'Pressure Sensors';
        } else {
          // Use regular sensors
          items = projectState.sensors.sensors || [];
          indexMap = projectState.sensors.indexMap || {};
          title = 'Sensors';
        }
        break;
      case routes.COUPLES:
        const selectedFeatureType =
          state.leaksList.leaksByProject.selectedFeatureType;
        if (selectedFeatureType === 'couple') {
          assessmentsData = projectState.assessments[selectedFeature];
        }
        if (displayAssessments && assessmentsData != null) {
          indexMap = assessmentsData.indexMap;
          if (!displayAssessmentsOnlyRealLeaks) {
            // Show All:
            items = assessmentsData.assessments;
          } else {
            items = assessmentsData.assessments.filter(
              (item) => [6, 3].indexOf(item.AlertState) !== -1
            ); // 6 = Fixed, 3 = Located
            // indexMap = items.map((item, index) => ({[item.id]: index }));
          }
        } else {
          items = projectState.couples.couples;
          indexMap = projectState.couples.indexMap;
        }
        hasAssessments =
          assessmentsData != null &&
          assessmentsData.assessments != null &&
          assessmentsData.assessments.length > 0;
        break;
      case routes.INSTALL:
        if (installContext === 'SOPs') {
          items = projectState.sops.sops;
          indexMap = projectState.sops.indexMap;
          title += ' > Installation Points';
        } else if (installContext === 'Sensors') {
          items = projectState.sensors.sensors;
          indexMap = projectState.sensors.indexMap;
          title += ' > Sensors';
        } else if (installContext === 'PressureSensors') {
          items = projectState.sensors.pressureSensors.items || [];
          indexMap = projectState.sensors.pressureSensors.indexMap || {};
          title += ' > Pressure Sensors';
        } else if (installContext === 'Interferences') {
          items = projectState.interferences.interferences;
          indexMap = projectState.interferences.indexMap;
          title += ' > Areas of Interest';
        }

        break;
      case routes.MANAGE:
        switch (managementContext) {
          case 'Customers':
            items = state.leaksList.customers.items;
            indexMap = state.leaksList.customers.indexMap;
            break;
          case 'Projects':
            items = state.leaksList.projectsList.items;
            indexMap = state.leaksList.projectsList.projectIndexMap;
            break;
          case 'Users':
            items = state.management.users;
            indexMap = state.management.usersIndexMap;
            break;
        }
        break;

      case routes.MOBILE: {
        switch (mobileDisplayMode) {
          case 'Tasks': {
            const {
              activeFilter,
              items: tasks,
              indexMap: tasksIndexMap,
              filteredIndexMap: tasksFilteredIndexMap,
              filteredItems: tasksFilterItems,
            } = state.mobile.tasks;
            items = activeFilter ? tasksFilterItems : tasks;
            indexMap = activeFilter ? tasksFilteredIndexMap : tasksIndexMap;
            title += ' Tasks';
            selectedFeature = state.mobile.tasks.selectedTask;
            break;
          }
          case 'Alerts': {
            const {
              activeFilter,
              items: alerts,
              indexMap: alertsIndexMap,
              filteredIndexMap: alertsFilteredIndexMap,
              filteredItems: alertsFilterItems,
            } = state.mobile.alerts;

            items = activeFilter ? alertsFilterItems : alerts;
            indexMap = activeFilter ? alertsFilteredIndexMap : alertsIndexMap;
            title += ' Alerts';
            selectedFeature = state.mobile.alerts.selectedAlert;
            break;
          }

          case 'Devices': {
            items = state.mobile.devices.items;
            indexMap = state.mobile.devices.indexMap;
            title += ' Devices';
            selectedFeature = state.mobile.devices.selectedDeviceId;
            break;
          }
        }

        break;
      }
      case routes.INPECT:
        // console.log(`Entered {case ${routes.INPECT}} in <CtableSwitch></CtableSwitch> to load relevant items `);
        // items = state.inspect;
        break;

      default:
        break;
    }
  }

  const customers = state.leaksList.customers;

  return {
    ...ownProps,
    title,
    items,
    indexMap,
    user,
    customers,
    filters,
    selectedProjectId,
    selectedFeature,
    alertsContextMenu,
    displayAssessments,
    displayAssessmentsOnlyRealLeaks,
    managementContext,
    selectedManageItem,
    manageItem: selectedManageItem,
    assessments: assessmentsData,
    hasAssessments,
    selectedAssessment,
    distanceFactor,
    timeZone,
    optionList,
    installContext,
    sensorsContext,
    planningState,
    isDisplayCityColumn,
    addingManualAlertMode,
    addingManualNoiseAlertMode,
    noiseAlertsSortParams,
    burstAlertsSortParams,
    mobileDisplayMode,
    mobileTasksSort,
    mobileAlertsSort,
    mobileDevicesSort,
    mobileTasksFilters,
    mobileAlertsFilters,
    valveAlertsFilters,
    burstAlertsFilters
  }
};


const getState = (dispatch) => new Promise((resolve) => {
  dispatch((dispatch, getState) => { resolve(getState()) })
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const { path } = ownProps;
  switch (ownProps.path) {
    case routes.INPECT:
      return {
        showHideAlerts: function () {
          // dispatch(actionsMapHandler.handleLayerChange(featuresTypes.INSPECT_ALERTS, value));
          ownProps.setMapLayersDisplay(null, featuresTypes.INSPECT_ALERTS);
        },
      };

    default:
      return {
        onItemClick: (item, onFailCallBack, additionalData) => {
          dispatch(actionsGlobals.setSelectedItem(item, onFailCallBack, additionalData));
        },
        selectTask: (item, isMulti) => {
          dispatch(mobileTasksActions.setSelectedTasks(item.task_uuid, isMulti));
        },
        onChangeMobileDisplayMode: async (modeContext) => {
          const state = await getState(dispatch);
          if (!modeContext) {
            return;
          }

          dispatch(actionsMobileDisplay.setDisplayMode(modeContext));
          if (modeContext === 'Tasks') {
            const taskState = state.mobile.tasks.selectedTask;
            dispatch(getSamples(taskState));
          } else {
            const selectedAlertId = state.mobile.alerts?.selectedAlert?.alert_id;
            if (!selectedAlertId) {
              return;
            }

            const selectedProject = state.leaksList.selectedProject;
            dispatch(getSamplesAction(selectedAlertId));
            dispatch(fetchMobileAlertSamples(selectedAlertId, selectedProject));
          }



        },
        sortTable: (field, dir) => {
          const { installMode } = ownProps;

          switch (path) {
            case 'alerts':
              dispatch((dispatch, getState) => {
                const state = getState();
                const alertsContext = state.leaksList.pressure.context;
                if (alertsContext === 'alerts') {
                  dispatch(actionsAlerts.sortLeaks(field, dir));
                } else {
                  dispatch(actionsPrsTranAlerts.sortAlerts(field, dir));
                }
              });
              break;
            case 'sensors':
              dispatch((dispatch, getState) => {
                const state = getState();
                const selectedProject = state.leaksList.selectedProject;
                const projectState = state.leaksList.leaksByProject[selectedProject];
                const sensorsContext = projectState && projectState.sensors ? projectState.sensors.sensorsContext : 'LeaksSensors';

                if (sensorsContext === 'PressureSensors') {
                  dispatch(actionsSensors.sortPressureSensors(field, dir));
                } else {
                  dispatch(actionsSensors.sortSensors(field, dir));
                }
              });
              break;
            case 'couples':
              dispatch(actionsCouples.sortCouples(field, dir));
              break;
            case 'install':
              const installContext = installMode.installContext;
              if (installContext === 'SOPs') {
                dispatch(actionsSOPs.sortSOPs(field, dir));
              } else if (installContext === 'Sensors') {
                dispatch(actionsSensors.sortSensors(field, dir));
              } else if (installContext === 'PressureSensors') {
                dispatch(actionsSensors.sortPressureSensors(field, dir));
              }
              // else if(installContext == 'Interference'){
              //   dispatch(actionsInterference.)
              // }
              break;
            case 'manage':
              switch (ownProps.managementContext) {
                case 'Users':
                  break;
                case 'Projects':
                  dispatch(actionsProjects.sortProjects(field, dir));
                  break;
                case 'Customers':
                  dispatch(actionsCustomers.sortCustomers(field, dir));
                  break;
              }
              break;
            case 'mobile':
              dispatch((dispatch, getState) => {
                const mobileDisplayMode = getState().mobile.modeState.mode;

                switch (mobileDisplayMode) {
                  case 'Tasks':
                    break;
                  case 'Alerts':
                    //todo filter
                    // dispatch(mobileAlertsActions.sortMobileAlerts(field, dir));
                    break;
                  case 'Devices':
                    dispatch(mobileDevicesActions.sortMobileDevices(field, dir));
                    break;
                  default:
                    break;
                }
              });
              break;

            default:
              break;
          }
        },
        addNewInstallItem: (key) => {
          const { selectedProject } = ownProps;
          // if (key == 'Interferences'){
          //  alert("INTERFERENCES PLUS BUTTON");
          // }
          // else if(key == 'SOPs'){
          //   alert("SOP'S PLUS BUTTON");
          // }

          if (key === 'PressureSensors') {
            // Install new pressure sensor - trigger map point selection mode
            dispatch(selectFeature(selectedProject, '', '', ''));
            dispatch(installActions.addNewPressureSensor());
            dispatch(setMapDrawMode(true, DRAW_TYPES.POINT));
            return;
          }

          dispatch(selectFeature(selectedProject, '', '', ''));
          dispatch(installActions.addNewSOP());

          if (key === 'Interferences') {
            dispatch(setMapDrawMode(true, DRAW_TYPES.CIRCLE));
          }
        },
        onChangeInstallContext: (key) => {
          // Our key that sent from the InstallMenu.js e.g "Interference\Sensors\SOPs\PrsSensors"
          dispatch(installActions.changeContext(key));
        },
        onChangeSensorsContext: (key) => {
          // Our key that sent from the SensorsMenu.js e.g "LeaksSensors\PressureSensors"
          dispatch(actionsSensors.changeSensorsContext(key));
        },
        // onChangeMobileDisplayMode: (mode) => {
        //   dispatch(actionsMobileDisplay.setDisplayMode(mode));
        // },
        deleteTask: (taskId) => {
          dispatch(mobileTasksActions.deleteTask(taskId));
        },
        addNewManualAlert: (isInMode) => {
          dispatch(actionsGlobals.setSelectedItem(null)); // unselect item.
          dispatch(
            setMapDrawMode(isInMode, DRAW_TYPES.POINT)
          );
          dispatch(actionsAlerts.setAddingNewManualAlertMode(isInMode));
          dispatch(reset('add-alert')); // clear add-alert form fields
        },
        addNewManualNoiseAlert: (isInMode) => {
          dispatch(actionsGlobals.setSelectedItem({})); // unselect item.
          dispatch(
            actionsNoiseAlerts.setAddingNewManualNoiseAlertMode(isInMode)
          );
          dispatch(reset('add-noise-alert')); // clear add-alert form fields
        },
        createAlertFromNoiseAlert: (noiseAlertId) => {
          dispatch(async (dispatch, getState) => {
            const state = getState();
            const noiseAlert = state.noiseAlerts.items[state.noiseAlerts.indexMap[noiseAlertId]];
            dispatch(actionsNoiseAlerts.selectNoiseAlert({}));
            dispatch(actionsPrsTranAlerts.changeAlertsContext('alerts'));

            await dispatch(actionsAlerts.setAddingNewManualAlertMode(true, noiseAlert.ID));
            await dispatch(setMapDrawMode(true, DRAW_TYPES.POINT));
            // await dispatch(actionsMapHandler.saveDrawnFeature([[noiseAlert.Longitude, noiseAlert.Latitude]]));

            dispatch(setFieldText('add-alert', 'ABC', 1));
            dispatch(setFieldText('add-alert', 'DetectionDateTime', new Date().toISOString().split('T')[0]));
            dispatch(setFieldText('add-alert', 'fixDate', new Date().toISOString().split('T')[0]));
            dispatch(setFieldText('add-alert', 'AlertState', noiseAlert.AlertState));
            dispatch(setFieldText('add-alert', 'AlertType', 0));
            // dispatch(setFieldText('add-alert', 'Coordinate', `${noiseAlert.Latitude}, ${noiseAlert.Longitude}`));
            dispatch(setFieldText('add-alert', 'Comment', `created from noise alert ${noiseAlert.ID}`));
          })
        },
        setCoupleAlertsShowOnlyRealLeaks: (show) => {
          dispatch(actionsAssessments.setCoupleAlertsShowOnlyRealLeaks(show));
        },
        loadPressureAlerts: (from, to) => {
          dispatch(actionsPrsTranAlerts.fetchPrsTransientAlerts(from, to));
        },
      };
  }
};

const CTableSwitch = connect(mapStateToProps, mapDispatchToProps)(TableSwitch);

export { CTableSwitch };

